import { render, staticRenderFns } from "./ViewCart.vue?vue&type=template&id=0fd0f72c&lang=true&"
import script from "./ViewCart.vue?vue&type=script&lang=js&"
export * from "./ViewCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports